// Loads labels from DOM elements data-json into a collection.
// JSON must be structured as an object with props 'collectionName' and 'labels'.
import Store from 'store'

document.querySelectorAll('[data-labels]').forEach((element) => {
    const data = JSON.parse(element.dataset.labels)

    if (Array.isArray(data)) {
        data.forEach((labels) => {
            Store.commit('labels/set_labelCollection', labels)
        })
        return
    }

    Store.commit('labels/set_labelCollection', data)
})
